import { j as t } from "../../../node_modules/react/jsx-runtime.js";
import { memo as c } from "react";
import p from "./ActivityFeedItem/ActivityItem.js";
import { Typography as d } from "../Typography/Typography.js";
const l = ({ data: m, timePosition: o, testId: i }) => /* @__PURE__ */ t.jsx("div", { "data-testid": i, children: m.map((a, e) => /* @__PURE__ */ t.jsxs(
  "div",
  {
    className: "flex flex-col gap-100",
    role: "feed",
    "data-testid": `${i}-${e}`,
    children: [
      /* @__PURE__ */ t.jsx(
        d,
        {
          text: a.date,
          variant: "subtitle-2",
          textColor: "color/fg/default",
          className: "pt-075 pb-125"
        }
      ),
      /* @__PURE__ */ t.jsx("div", { className: "flex flex-col gap-100", children: a.items.map((r, s) => /* @__PURE__ */ t.jsx(
        p,
        {
          item: r,
          timePosition: o,
          isLastItem: m.length - 1 === e && a.items.length - 1 === s,
          "data-testid": `${i}-${e}-item-${s}`
        },
        s
      )) })
    ]
  },
  e
)) });
l.displayName = "ActivityFeed";
const y = c(l);
export {
  y as default
};
//# sourceMappingURL=ActivityFeed.js.map
